<template>
  <div>
    <Loading v-if="load"/>
    <div v-if="activated" :id="nameApp"></div>
  </div>
</template>

<script>
import Loading from '@/components/Loading';
import { mapGetters, mapState } from 'vuex';
import types from '@/constants/types';
import gtmRegister from '@/functions/analitics';

export default {
  name: 'WidgetLoad',
  components: {
    Loading,
  },
  data() {
    return {
      text: '',
      nameApp: 'details',
      load: false,
      activated: false,
    };
  },
  computed: {
    ...mapGetters({
      data: 'getData',
    }),
    ...mapState({
      validateBeneficiaryData: state => state.async[types.async.GET_VALIDATE_BENEFICIARY].data,
    }),
  },
  methods: {
    loading(value) {
      this.load = value;
    },
  },
  mounted() {
    if (this.data.token === '' && !this.data.isLogged) {
      this.$router.push({ path: '/' });
      return;
    }
    const data = this.$router.history.router.options.routes;
    const { name } = this.$router.history.current;
    const rutes = data.filter(info => info.name === name);
    this.nameApp = rutes[0].nameWidget;
    this.activated = true;
    this.$loadScript(rutes[0].direction)
      .then(async () => {
        const win = window;
        await win[rutes[0].nameFunction].init(
          {
            token: this.data.token,
            clientData: {
              rut: this.data.rut,
              dv: this.data.dv,
              names: this.data.names,
              idClient: this.data.idClient,
              surname: this.data.surname,
              secondSurname: this.data.secondSurname,
              account: 1,
              validateBeneficiary: this.validateBeneficiaryData.data.enabled,
            },
            registryGtm: (info) => {
              gtmRegister(info, this);
            },
            loading: value => this.loading(value),
            back: () => { this.$router.push('/home'); },
            changePage: (page) => { this.$router.push({ path: page }); },
          },
        );
      })
      .catch(() => {
      // Failed to fetch script
      });
  },
};
</script>

<style lang="scss" module>

.divComponent {
  position: relative;
  margin-bottom: 20px;
}

.divComponentError {
  position: relative;
}

.link {
  display: flex;
  margin-top: 10px;
}

.linkWithError {
  position: relative;
  bottom: 15px;
  display: flex;
}

.icon {
  padding-right: 7px;
}
</style>
